<template>
  <div
    class="d-flex align-items-center h-100 overflow-hidden"
    :class="{ 'is-fleet-partner-only': isFleetPartnerOnly }"
  >
    <img
      v-if="!isFleetPartnerOnly && !isApiPartnerOnly"
      src="@/assets/images/giftools.gif"
      alt="gif"
    />

    <div v-if="isFleetPartnerOnly" style="height: 36px; width: 36px">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%">
        <g transform="translate(0, 24)">
          <g stroke="#ffffff" stroke-width="1.5" stroke-linecap="round">
            <g>
              <animateTransform
                attributeName="transform"
                type="translate"
                from="100 0"
                to="-50 0"
                dur="1.5s"
                repeatCount="indefinite"
              />
              <line x1="0" y1="53" x2="15" y2="53" />
            </g>
            <g>
              <animateTransform
                attributeName="transform"
                type="translate"
                from="160 0"
                to="-50 0"
                dur="1.5s"
                repeatCount="indefinite"
              />
              <line x1="0" y1="53" x2="25" y2="53" />
            </g>
            <g>
              <animateTransform
                attributeName="transform"
                type="translate"
                from="130 0"
                to="-50 0"
                dur="1.2s"
                repeatCount="indefinite"
              />
              <line x1="0" y1="0" x2="30" y2="0" stroke-width="1" opacity="0.4" />
            </g>
          </g>

          <g stroke-linejoin="round" stroke-linecap="round">
            <animateTransform
              attributeName="transform"
              type="translate"
              values="0,0; 0,-1; 0,0"
              dur="0.8s"
              repeatCount="indefinite"
            />

            <path
              fill="#00a1fe"
              stroke="#00a1fe"
              stroke-width="2.5"
              fill-rule="evenodd"
              d="M 12 42 L 12 24 L 22 24 L 32 4 L 55 4 L 68 24 L 88 24 L 88 42 L 82 42 A 12 12 0 0 0 58 42 L 42 42 A 12 12 0 0 0 18 42 Z
               M 24 24 L 33 6 L 43 6 L 43 24 Z
               M 47 6 L 54 6 L 65 24 L 47 24 Z"
            />

            <line x1="85" y1="30" x2="88" y2="30" stroke="#ffffff" stroke-width="2.5" />
            <line x1="12" y1="30" x2="15" y2="30" stroke="#ffffff" stroke-width="2.5" />

            <g transform="translate(30, 42)">
              <circle cx="0" cy="0" r="8" fill="none" stroke="#00a1fe" stroke-width="3.5" />
            </g>

            <g transform="translate(70, 42)">
              <circle cx="0" cy="0" r="8" fill="none" stroke="#00a1fe" stroke-width="3.5" />
            </g>
          </g>
        </g>
      </svg>
    </div>

    <div v-if="isApiPartnerOnly" style="height: 30px; width: 30px">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="100%" height="100%">
        <g
          class="gear-icon"
          stroke="#2e3482"
          fill="none"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M 50 5
             C 53 5 55 7 56 10 L 58 16
             A 35 35 0 0 1 66 19 L 71 14
             C 73 12 76 12 78 14 L 86 22
             C 88 24 88 27 86 29 L 81 34
             A 35 35 0 0 1 84 42 L 90 44
             C 93 45 95 47 95 50
             C 95 53 93 55 90 56 L 84 58
             A 35 35 0 0 1 81 66 L 86 71
             C 88 73 88 76 86 78 L 78 86
             C 76 88 73 88 71 86 L 66 81
             A 35 35 0 0 1 58 84 L 56 90
             C 55 93 53 95 50 95
             C 47 95 45 93 44 90 L 42 84
             A 35 35 0 0 1 34 81 L 29 86
             C 27 88 24 88 22 86 L 14 78
             C 12 76 12 73 14 71 L 19 66
             A 35 35 0 0 1 16 58 L 10 56
             C 7 55 5 53 5 50
             C 5 47 7 45 10 44 L 16 42
             A 35 35 0 0 1 19 34 L 14 29
             C 12 27 12 24 14 22 L 22 14
             C 24 12 27 12 29 14 L 34 19
             A 35 35 0 0 1 42 16 L 44 10
             C 45 7 47 5 50 5 Z"
          />

          <circle cx="50" cy="50" r="25" />
        </g>

        <g
          fill="none"
          stroke="#2e3482"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <animateTransform
            attributeName="transform"
            type="translate"
            values="0,0; 0,-1.5; 0,0"
            dur="3s"
            repeatCount="indefinite"
          />

          <polyline points="43,40 34,50 43,60" />

          <line x1="54" y1="37" x2="47" y2="63" />

          <polyline points="57,40 66,50 57,60" />
        </g>
      </svg>
    </div>

    <div class="d-flex flex-column align-items-start ps-2 overflow-hidden">
      <p class="welcome-title text-nowrap text-truncate" :title="partnerVersionMessage">
        {{ partnerVersionMessage }}
        <span v-if="partnerLegalName" class="version-subtitle text-nowrap text-truncate">{{
          portalVersionLabel
        }}</span>
      </p>
      <span
        v-if="partnerLegalName"
        class="welcome-subtitle text-nowrap text-truncate"
        :title="partnerLegalName"
      >
        {{ partnerLegalName }}
      </span>
      <span v-else class="version-subtitle text-nowrap text-truncate">{{
        portalVersionLabel
      }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { getUserAddDataFromLocalStorage } from '@/utils/userUtils';
import { usePartnerType } from '@/composables/common';
import { PORTAL_VERSIONS } from '@/constants/portal-versions';

const { t } = useI18n();
const { isFleetPartnerOnly, isApiPartnerOnly } = usePartnerType();
const { firstName, lastName, partnerTypes, partnerSettings, timezone } =
  getUserAddDataFromLocalStorage();
const partnerLegalName = partnerSettings?.mainSponsor?.partnerProfile?.legalName;

const partnerVersionMessage = computed(() => {
  if (firstName || lastName) return getGreeting();
  return t('global.header.welcome.defaultPortal');
});

const portalVersionLabel = computed(() => getPortalVersionLabel());

function getPortalVersionLabel() {
  if (!partnerTypes || partnerTypes.length === 0) return null;

  // Read from PORTAL_VERSIONS rather than a local copy: this header and the
  // changelog pages previously kept separate lists and silently drifted apart.
  let highestVersion = 'v1.0.0';
  partnerTypes.forEach((type) => {
    const currentVersion = PORTAL_VERSIONS[type]?.version;
    if (currentVersion && compareVersions(currentVersion, highestVersion) > 0) {
      highestVersion = currentVersion;
    }
  });

  if (partnerTypes.length === 1) {
    switch (partnerTypes[0]) {
      case 'RYD_INTERNAL':
        return `${t('global.header.welcome.rydInternalPortal')} ${highestVersion}`;
      case 'FLEET_PARTNER':
        return ``;
      case 'API_PARTNER':
        return `${t('global.header.welcome.apiPartnerPortal')} ${highestVersion}`;
      case 'ENERGY_NETWORK_PARTNER':
        return `${t('global.header.welcome.energyNetworkPartnerPortal')} ${highestVersion}`;
      case 'INDIVIDUAL_PARTNER':
        return `${t('global.header.welcome.partnerPortal')} ${highestVersion}`;
      default:
        return `${t('global.header.welcome.defaultPortal')} ${highestVersion}`;
    }
  }

  return `${t('global.header.welcome.defaultPortal')}`;
}

function getGreeting() {
  const hour = getHourInTimezone(timezone);
  const params = { firstName: firstName || '', lastName: lastName || '' };

  if (hour >= 6 && hour < 12) {
    return t('global.header.welcome.goodMorning', params);
  } else if (hour >= 12 && hour < 18) {
    return t('global.header.welcome.goodAfternoon', params);
  } else {
    return t('global.header.welcome.goodEvening', params);
  }
}

function getHourInTimezone(tz) {
  const now = new Date();
  if (tz) {
    try {
      return parseInt(
        new Intl.DateTimeFormat('en-US', { hour: 'numeric', hour12: false, timeZone: tz }).format(
          now,
        ),
        10,
      );
    } catch {
      // fall through to local time
    }
  }
  return now.getHours();
}

function compareVersions(version1, version2) {
  const v1Parts = version1.replace('v', '').split('.').map(Number);
  const v2Parts = version2.replace('v', '').split('.').map(Number);

  for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
    const v1Part = v1Parts[i] || 0;
    const v2Part = v2Parts[i] || 0;
    if (v1Part > v2Part) return 1;
    if (v1Part < v2Part) return -1;
  }
  return 0;
}
</script>

<style lang="scss">
@import '@/assets/scss/utils/_variables.scss';

.welcome-title {
  font-size: 16px;
  line-height: 21px;
  color: rgba($primary-color, 0.9);
  margin-bottom: 0;
  display: block;
  width: 100%;
  overflow: hidden;
}
.welcome-subtitle {
  font-size: 12px;
  line-height: 12px;
  color: rgba($primary-color, 0.7);
  margin-bottom: 0;
  display: block;
  width: 100%;
  overflow: hidden;
  padding-top: 2px;
}

.version-subtitle {
  font-size: 12px;
  line-height: 12px;
  color: $font-gray-color;
  padding-top: 2px;
}

.gear-icon {
  transform-box: fill-box;
  transform-origin: center;
  animation: gear-spin 12s linear infinite;
}

@keyframes gear-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.is-fleet-partner-only {
  .welcome-title {
    color: $white;
  }

  .welcome-subtitle {
    color: rgba($white, 0.7);
  }

  .version-subtitle {
    color: rgba($white, 0.6);
  }
}
</style>
